import { render, staticRenderFns } from "./ProductApprovalFormApproval.vue?vue&type=template&id=0e2b60cc"
import script from "./ProductApprovalFormApproval.vue?vue&type=script&lang=js"
export * from "./ProductApprovalFormApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports